var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        ref: "form-step-one",
        attrs: {
          method: "post",
          action:
            _vm.state.selectedLocation && _vm.state.selectedLocation.orderUrl,
        },
      },
      [
        _vm.state.isOrderProductLoading
          ? _c("loading-animation", {
              attrs: { "loading-title": _vm.getFancyLoadingTitle() },
            })
          : _vm.state.isOrderProductFailure
          ? _c("strong", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.i18n.t("checkout:stepone.order_product_failure")) +
                  "\n    "
              ),
            ])
          : _vm.state.isOrderProductAvailable
          ? [
              _c(
                "div",
                { staticClass: "panel order__box" },
                [
                  _c(
                    "div",
                    { staticClass: "order__box__configuration" },
                    [
                      _c("h2", { staticClass: "panel__title" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.i18n.t("checkout:stepone.title")) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { "margin-bottom": "50px" } },
                        [
                          _vm.state.productKey === "minecraft"
                            ? _c("minecraft-ram-unit-select", {
                                attrs: {
                                  "slider-width": _vm.sliderOptions.width,
                                  "slider-marker": _vm.sliderMarker,
                                },
                                model: {
                                  value: _vm.state.selectedUnits,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.state, "selectedUnits", $$v)
                                  },
                                  expression: "state.selectedUnits",
                                },
                              })
                            : [
                                _c(
                                  "label",
                                  { staticClass: "order__box__range-label" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.i18n.t(
                                            "checkout:stepone.units.title",
                                            {
                                              unitName: _vm.i18n.t(
                                                _vm.state.product.cloudUnitType
                                                  .loco_key
                                              ),
                                            }
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.number.lazy",
                                          value: _vm.state.selectedUnits,
                                          expression: "state.selectedUnits",
                                          modifiers: {
                                            number: true,
                                            lazy: true,
                                          },
                                        },
                                      ],
                                      staticClass: "input-uislider",
                                      attrs: {
                                        id: "input-units",
                                        "data-test-units":
                                          _vm.state.selectedUnits,
                                        min: _vm.state.minUnits,
                                        max: _vm.state.maxUnits,
                                        disabled:
                                          _vm.state.isOrderProductPriceLoading,
                                        pattern: "[0-9]*",
                                        name: "data[Order][units]",
                                        type: "number",
                                      },
                                      domProps: {
                                        value: _vm.state.selectedUnits,
                                      },
                                      on: {
                                        keydown: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          $event.preventDefault()
                                        },
                                        change: function ($event) {
                                          _vm.$set(
                                            _vm.state,
                                            "selectedUnits",
                                            _vm._n($event.target.value)
                                          )
                                        },
                                        blur: function ($event) {
                                          return _vm.$forceUpdate()
                                        },
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("vue-smart-slider", {
                                  attrs: {
                                    width: _vm.sliderOptions.width,
                                    marker: _vm.sliderMarker,
                                    min: _vm.state.minUnits,
                                    max: _vm.state.maxUnits,
                                    disabled:
                                      _vm.state.isOrderProductPriceLoading,
                                    "prop-default-value":
                                      _vm.state.selectedUnits,
                                    "prop-value": _vm.state.selectedUnits,
                                    "prop-fixed-pips":
                                      _vm.state.productKey === "hll",
                                    "prop-floating-values": false,
                                  },
                                  on: {
                                    "on-slider-dragging": function (newValue) {
                                      return (_vm.state.selectedUnits =
                                        newValue)
                                    },
                                    "on-slider-dragged": function ($event) {
                                      _vm.state.selectedUnits = $event
                                    },
                                    "on-slider-clicked": function ($event) {
                                      _vm.state.selectedUnits = $event
                                    },
                                  },
                                }),
                              ],
                          _vm._v(" "),
                          _c("base-extension-selection", {
                            staticStyle: { "margin-top": "20px" },
                            attrs: {
                              extensions: _vm.state.product.extensions,
                              prices: _vm.state.extensionPrices,
                            },
                            model: {
                              value: _vm.state.selectedExtensions,
                              callback: function ($$v) {
                                _vm.$set(_vm.state, "selectedExtensions", $$v)
                              },
                              expression: "state.selectedExtensions",
                            },
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      "productKey" in _vm.route.params
                        ? [
                            _c(
                              "div",
                              { staticClass: "order__box__benefits" },
                              [
                                _vm.route.params.productKey === "atlas"
                                  ? _c("atlas-checkout-info", {
                                      attrs: { slots: _vm.state.selectedUnits },
                                    })
                                  : _vm.route.params.productKey ===
                                    "war-of-rights"
                                  ? _c("war-of-rights-checkout-info")
                                  : _vm.route.params.productKey === "rust"
                                  ? _c("rust-checkout-info", {
                                      attrs: { slots: _vm.state.selectedUnits },
                                    })
                                  : _vm.route.params.productKey === "hurtworld"
                                  ? _c("hurtworld-checkout-info", {
                                      attrs: { slots: _vm.state.selectedUnits },
                                    })
                                  : _vm.route.params.productKey === "blackwake"
                                  ? _c("blackwake-checkout-info", {
                                      attrs: { slots: _vm.state.selectedUnits },
                                    })
                                  : _vm.route.params.productKey ===
                                    "hellLetLoose"
                                  ? _c("hell-let-loose-game-info")
                                  : _vm.route.params.productKey === "vrising"
                                  ? _c("v-rising-checkout-info")
                                  : _vm.route.params.productKey ===
                                    "frozenFlame"
                                  ? _c("frozen-flame-checkout-info")
                                  : _vm.route.params.productKey === "icarus"
                                  ? _c("icarus-checkout-info")
                                  : _vm.route.params.productKey ===
                                    "arksurvival"
                                  ? _c("ark-survival-checkout-info")
                                  : _vm.route.params.productKey === "enshrouded"
                                  ? _c("enshrouded-checkout-info")
                                  : _vm.route.params.productKey ===
                                    "abiotic-factor"
                                  ? _c("abiotic-factor-checkout-info")
                                  : _vm.route.params.productKey === "fivem"
                                  ? _c("five-m-checkout-info")
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("h2", [
                        _vm._v(
                          _vm._s(_vm.$t("general:non_special_texts.duration"))
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.state.selectedLocation
                        ? _c("checkout-contract-duration-list", {
                            attrs: {
                              "selected-contract-duration":
                                _vm.state.selectedDuration,
                              "contract-durations":
                                _vm.state.selectedLocation.product.durations,
                            },
                            on: {
                              "contract-select": function ($event) {
                                _vm.state.selectedDuration = $event
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("h2", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("checkout:stepone.available_locations.title")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("checkout-location-list", {
                        attrs: {
                          selected: _vm.state.selectedLocation,
                          locations: _vm.state.productLocations,
                        },
                        on: {
                          "location-select": function ($event) {
                            _vm.state.selectedLocation = $event
                          },
                        },
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.state.selectedLocation
                    ? _c("checkout-price", {
                        attrs: {
                          "disable-payment": false,
                          "is-vat-required": _vm.shouldDisplayVat(),
                          "location-check":
                            _vm.state.selectedLocation.available,
                          "switch-region": _vm.regionSwitchRequired,
                        },
                        on: { "on-order-submit": _vm.onOrderSubmit },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "layout-two-cols" }, [
                _c(
                  "div",
                  [_c("trust-symbols"), _vm._v(" "), _c("customer-advantages")],
                  1
                ),
                _vm._v(" "),
                _c("div", [_c("payment-methods")], 1),
              ]),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _vm.state.regionModalVisible
      ? _c(
          "div",
          { staticClass: "bs" },
          [
            _c("region-switcher-modal", {
              on: {
                "on-accept-click": _vm.onRegionSwitcherModalAccept,
                "on-cancel-click": function ($event) {
                  _vm.state.regionModalVisible = false
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }